export default {
      id: "download-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#download",
      toString: function () {
        return this.url;
      }
    }